module.exports = __webpack_public_path__ + "img/banner.fd287b07.png";